import React, { Suspense } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AppLoading } from 'presentation/components/AppLoading';
import { IRoute, AppRouter } from 'presentation/components/AppRouter';

const App = React.lazy(() => import('./App'));
const AppLegacy = React.lazy(() => import('./presentation/legacy/App'));

function AppWrap() {
  return (
    <Suspense fallback={<AppLoading />}>
      <App />
    </Suspense>
  );
}

function AppLegacyWrap() {
  return (
    <Suspense fallback={<AppLoading />}>
      <AppLegacy />
    </Suspense>
  );
}

export const AppRouterBridge = () => {
  const routes: IRoute[] = [
    {
      key: 'APP_LEGACY',
      component: AppLegacyWrap,
      path: '/legacy',
      exact: false,
    },
    {
      key: 'APP',
      component: AppWrap,
      path: '/',
      exact: false,
    },
  ];
  return (
    <Router>
      <AppRouter routes={routes} />
    </Router>
  );
};
